import React, { useState, useEffect } from "react";
import { useProductStore } from "src/hooks/product";
import AxiosIndicatorRunTimeLoader from "src/component/Global/AxiosIndicatorRunTimeLoader";
import { __set, } from "src/store/axios_indicator";
import System from "src/helper/system";
import TopProductDetail from "../ProductDetail/ProductDetailLeftContent/TopProductDetail/TopProductDetail";
import ProductDetailTabs from "../ProductDetail/ProductDetailLeftContent/ProductDetailTabs/ProductDetailTabs";
import ProductDetailBuyBox from "../ProductDetail/ProductDetailRightContent/ProductDetailBuyBox";
import ProductDetailAd from "../ProductDetail/ProductDetailRightContent/ProductDetailAd";
import Helper from "../../helper/Helper";
import $ from "jquery";
import { ProductDetailEsop } from "../ProductDetail/ProductDetailRightContent/ProductDetailEsop";
import ShowAlert from "src/component/Global/ShowAlert";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import HelperAnalyticsEvent from "src/support/HelperAnalyticsEvent";
import Constants from "src/helper/Constants";
import AdditionalStock from "src/component/custom/AdditionalStock";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import HolidayEspot from "src/assets/images/HolidayEspot.png"

export function ProductDetail() {
  const { translation: t } = System;
  let c = System.getParams();
  const [{ productList }, { get_product_assets, get_product_detail }, { }] = useProductStore();
  const [loader, setLoader] = useState(true)
  const url = window.location.href?.split('?')[0];
  const urlAry = url?.split('/').filter(data => data.length > 0);
  const ItemNumber = Helper.toUpperCase(urlAry[urlAry.length - 1]);
  const [parentClass, setParentClass] = useState('');
  const [{ inventoryList }, { get_pricing_by_id }, { }] = useProductInventoryPriceStore();
  const [productData, setProductData] = useState([]);

  const [isProdViewEvent, setProdViewEvent] = useState(true)
  const [__check] = useAxiosIndicatorCheck();
  const [bdpBuyBoxHeight, setPdpBuyBoxHeight] = useState('');
  const [monitorFunctionCall, setMonitorFunctionCall] = useState({monitorJs: false, frameworkReady: false});
  useEffect(() => {
    async function fetchHere() {
      await fetchProductDetailFromServer();
    }
    __set('PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING')
    fetchHere();
  }, [ItemNumber]);

  const fetchProductDetailFromServer = async () => {
    __set('PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING')

    if (ItemNumber) {
      const res = await get_product_detail([{ ItemNumber: ItemNumber, SEOItemNumber: ItemNumber }], true)
       if (!monitorFunctionCall?.frameworkReady) {
          System.monitorFrameWorkReady()
          setMonitorFunctionCall({...monitorFunctionCall, frameworkReady: true})
        }
      setProductData(Object.keys(res))
      setLoader(false)
    }
  };

  useEffect(() => {
    async function fetchHere() {
      if (productList && productList[productData] && Object.keys(productList[productData]).length > 0) {
        // let topProducts = []
        // topProducts = [...productList[ItemNumber].TopProducts]
        // topProducts = topProducts.map(v => ({
        //   ...v,
        //   exists_in_sap: !!v.exists_in_sap,
        //   factory_qoh: v.factory_qoh ? parseInt(v.factory_qoh) : 0,
        //   default_plant: v.default_plant ? v.default_plant : "",
        //   MDMMaterialID: v.MDMMaterialID ? v.MDMMaterialID : ""
        // }));

        let product = { ...productList[productData] };
        if (c.searchTerm) {
          const searchedCPN = c.searchTerm;
          let cpnAvailable = System.isCPNAvailableInList(product, searchedCPN)
          if (cpnAvailable) {
            product.CPN = searchedCPN

          }
        }

        // topProducts.push(product);
        await get_product_assets([product])
      }
    }
    fetchHere()



  }, [productList])

  useEffect(() => {
    if (productList[productData] && Object.keys(inventoryList).length && isProdViewEvent &&
      !__check(['PRODUCT_ASSET_API_CALL']).status) {
      productViewEvent(productList[productData]);
      setProdViewEvent(false)
    }
  }, [__check(['PRODUCT_ASSET_API_CALL']).status])

  const productViewEvent = (product) => {
    let currentProd = [product];
    if (currentProd?.length > 0) {
      let productArr = currentProd.map((x) => {
        let priceObj = get_pricing_by_id({ ItemNumber: x?.ItemNumber })?.[0];
        return {
          ...x,
          qas: x?.Stock || 0,
          unitPrice: x?.unitPrice || priceObj?.marketPrice || 0,
          subtotal: x?.subtotal || (priceObj?.marketPrice * priceObj?.quantity) || 0,
          quantity: x?.Quantity || priceObj?.quantity || x?.QtyMin,
          priceSource: priceObj?.priceSource || ''
        }
      });
      let productView = {
        productList: productArr
      }
      HelperAnalyticsEvent.productView(productView)
    }
  }

  useEffect(() => {
    Helper.feedBackButtonScript()
  }, []);

  return (
    <>
      <div className="logged-screen">
        <>
          <ShowAlert doNotShow={['productDetailsErr','productCompare']} />
          {loader ?
            <>
              <AxiosIndicatorRunTimeLoader overlay={true} />
            </> :
            <>
              {productList[productData] && (
                <>
                  <ShowAlert onlyShowMessage={['productDetailsErr']} />

                  <div className="container pdp-container">
                    <div className="bs5 row pdp-row">
                      <div className="col-xl-8 col-lg-7 pdp-container-left">
                        <div className="col-12">
                          <TopProductDetail productDetail={productList[productData]} />
                          <div className="desktophide mobileshow mt-3">
                            <ProductDetailBuyBox productDetail={productList[productData]} />
                          </div>
                          <ProductDetailTabs productDetail={productList[productData]} />
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-5 mt-3 mt-lg-0 pdp-container-right">
                        <div className='product-detail-right mobilehide desktopshow' style={{
                          top: $(".header").height()
                        }}>

                          <div className="icon-list icon-list-inline justify-content-end text-13 d-none d-sm-flex">
                            <a key={Helper.UUID()} onClick={() => { window.print() }} className="icon-list-item text-black">
                              <i className="fa fa-print" />
                              <span className="text-blue">{t('print')}</span>
                            </a>
                            {/* <a key={Helper.UUID()} style={{ cursor: 'pointer' }} onClick={onShare} className="icon-list-item text-black">
                            <i className="fa fa-share-alt" />
                            <span className="text-blue">Share</span>
                        </a> */}
                            {/* <a key={Helper.UUID()} style={{ cursor: 'pointer' }} onClick={() => {
                              System.popup('SendEmailOfReportError', { productDetail: productList[ItemNumber] })
                            }} className="icon-list-item text-black">
                              <i className="fa fa-unlink" />
                              <span className="text-blue">Report Error</span>
                            </a> */}
                          </div>
                          <div className={parentClass} style={{ height: bdpBuyBoxHeight }} id="stock-box-pdp">
                            <ProductDetailBuyBox setParentClass={setParentClass} setPdpBuyBoxHeight={setPdpBuyBoxHeight} productDetail={productList[productData]} />
                          </div>
                          <div >
                            <div id='stock-box'>
                              {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) && productList[productData].FarnellInventorySharing &&
                                <AdditionalStock isFrom={'PDP'} erpPartNumber={productList[productData]} />}
                            </div>
                            <div id='esop-box'>
                              <ProductDetailEsop />
                              {System.getCurrentRegionWithType(Constants.speedBoats.japanAbbr) && <img src={HolidayEspot}/>}
                            </div>
                          </div>
                        </div>
                        <div className='mobileads mt-3'>
                          <ProductDetailAd />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          }
        </>
      </div>
    </>
  );
}